import React from "react";
import { useTranslation } from "react-i18next";

const Notfound = (props) => {
  const { t } = useTranslation();
  return (
    <div className="notfound-block">
      <img
        src={require("assets/images/404.svg").default}
        className="img-fluid"
      />
      <h3> {t("NotFoundComponent.title")}</h3>
      <p> {t("NotFoundComponent.text")}</p>
      <button
        className="button button-rounded button-height-meidum"
        onClick={() => props.history.goBack()}
        title={t("commonComponent.backbutton")}
      >
        {t("commonComponent.backbutton")}
      </button>
    </div>
  );
};

export default Notfound;
